import Mission from '../components/about/mission';
import Team from '../components/about/team';
import Specifics from '../components/about/specifics';

const members = [
    {
        name: 'David Bradham',
        title: 'Co-founder',
        bio: 'Based in Austin, I specialize in property management software solutions'
    },
    {
        name: 'Ibrahim Yaro',
        title: 'Co-founder',
        bio: 'Based in Austin, I help property owners maximize their rental income!'
    }
];

const About = () => {
    // 1- mission statement and big picture impact
    // 2- where and who they are
    // 3- specifics
    return <div>
        <Mission />
        <Team members={members} />
        <section className="about-advisory-section">
            <div className="about-advisory-shell">
                <h3>Advisory Support For First-Time Operators</h3>
                <p>
                    We do more than provide tooling. For owners and teams just entering short-term rentals, we can help think through launch sequencing,
                    operational priorities, reporting habits, and the systems needed to run a disciplined business from day one.
                </p>
                <div className="about-advisory-grid">
                    <article className="about-advisory-card">
                        <h4>Launch Planning</h4>
                        <p>Clarify what has to be in place before a property goes live, from workflows to compliance documentation.</p>
                    </article>
                    <article className="about-advisory-card">
                        <h4>Operational Reviews</h4>
                        <p>Build simple review routines around revenue, expenses, vendor performance, and guest experience.</p>
                    </article>
                    <article className="about-advisory-card">
                        <h4>Decision Support</h4>
                        <p>Get experienced guidance while evaluating tools, processes, and where to focus first as the business grows.</p>
                    </article>
                </div>
            </div>
        </section>
        <Specifics />
    </div>
};

export default About;